module.exports = __webpack_public_path__ + "img/pin-juragan.ec1d86e2.svg";